import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../CompanyDetails/CompanyDetails.css";
import { trackEvent, trackPageView } from "../../utils/tracking";

function CompanyDetails() {
  useEffect(() => {
    trackPageView(
      "https://www.jmfinancialmf.com/Reach-Us/CompanyDetails",
      "jmf_reach-us_company-details"
    );

    trackEvent({
      category: "Dynamic Page",
      action: "Company Details Page Loaded",
      label: "jmf_reach-us_company-details",
      // value: 1,
    });
  }, []);

  return (
    <>
      <section className="company-section">
        <div className="section-header">
          <h2>Company Details</h2>
          <p>JM Financial Asset Management Limited</p>
        </div>
        <div className="company-details-main">
          <div>
            <h6>Registered Office</h6>
            <p>
              7th Floor, Cnergy , Appasaheb Marathe Marg, Prabhadevi , Mumbai
              400025.
            </p>
          </div>
          <div>
            <h6>Corporate Office</h6>
            <p>
              One International Centre, 22nd Floor, Tower 2, Senapati Bapat
              Marg, Prabhadevi, Mumbai – 400013.
            </p>
            <p>
              Tel. No.: (022) 6198 7777<br></br>
              Fax No.: (022) 6198 7704
            </p>
          </div>
          <div>
            <h6>Corporate Identity Number</h6>
            U65991MH1994PLC078879<br></br>
          </div>
        </div>
      </section>
    </>
  );
}

export default CompanyDetails;
